import type { Acquirable } from "../acquire/acquirable";
import { getBookableResourceReferences } from "../acquire/bookable";
import { isBookable } from "../acquire/is-bookable";
import { bookableOptionPriceCalculator } from "../acquire/resource-reference-options/bookable-option-price-calculator";
import type { BookableOptionValue } from "../acquire/resource-reference-options/bookable-option-value";
import { isQuantityPickerBookableOption } from "../acquire/resource-reference-options/quantity-picker-bookable-option";
import { isQuantityPickerBookableOptionValue } from "../acquire/resource-reference-options/quantity-picker-bookable-option-value";
import type { BookableSession } from "../acquire/sessions/bookable-session";
import { convertTimeByGranularity } from "../date-time/time-granularity";
import { zeroPrice } from "../prices/price";
import { sumPrices } from "../prices/sum-prices";

const calculateMinPrice = (
    sku: Acquirable,
    sessions: BookableSession[],
    overrideBookableOption: BookableOptionValue[] = [],
) => {
    if (isBookable(sku)) {
        if (sessions.length === 0) return zeroPrice;
        //Should this be saved on sessions

        const minTime =
            sessions.length === 0
                ? 1
                : (Math.min(...sessions.map(s => s.durationMinMax.min)) ?? 1);
        const granularity =
            sessions.length === 0 ? "HOUR" : sessions[0].durationGranularity;

        const references = getBookableResourceReferences(sku);

        const prices = references.flatMap(resourceReference =>
            resourceReference.options.flatMap(option => {
                //overrideBookableOption
                const override = overrideBookableOption.find(
                    o => o.parentId === option._id,
                );

                const overrideQuanity = isQuantityPickerBookableOptionValue(
                    override,
                )
                    ? override.quantity
                    : undefined;
                return bookableOptionPriceCalculator({
                    bookedMinutes: convertTimeByGranularity(
                        minTime,
                        granularity,
                        "MINUTE",
                    ),
                    quantity:
                        overrideQuanity?.value ||
                        (isQuantityPickerBookableOption(option) &&
                            (option.default || option.minMax.min)) ||
                        0,
                    option,
                });
            }),
        );

        return sumPrices([sku.price, ...prices]);
    }
    return sku.price;
};

export { calculateMinPrice };
